import { Grid, Typography, Card, Box } from "@mui/material";
import React, { useEffect, useRef } from "react";
import Viewer from "viewerjs";

interface IDetails {
  header: string;
  dataList: { [key: string]: { value: string | undefined; isImage?: boolean } };
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  sx?: any;
}
const Details = ({ header, dataList, sx }: IDetails) => {
  const imageViewer = useRef(null);
  useEffect(() => {
    let viewer: Viewer;
    if (imageViewer.current) {
      viewer = new Viewer(imageViewer.current, { navbar: false });
    }
    return () => {
      if (viewer) {
        viewer.destroy();
      }
    };
  }, [dataList]);

  return (
    <Box sx={sx}>
      <Typography variant="h3" mb="25px">
        {header}
      </Typography>
      <Card sx={{ py: "27px", px: "44px" }}>
        <Grid container rowSpacing="35px">
          {Object.entries(dataList).map(([key, data]) => (
            <React.Fragment key={key}>
              <Grid item xs={3}>
                <Typography variant="body3"> {key}</Typography>
              </Grid>
              <Grid item xs={9}>
                {data.isImage ? (
                  <Box
                    component="img"
                    src={data.value}
                    maxWidth="160px"
                    maxHeight="160px"
                    sx={{
                      objectFit: "cover",
                      "&:hover": { cursor: "zoom-in" },
                    }}
                    ref={imageViewer}
                  />
                ) : (
                  <Typography
                    component="p"
                    variant="body3"
                    fontWeight="600"
                    sx={{ overflowWrap: "break-word" }}
                  >
                    {data.value}
                  </Typography>
                )}
              </Grid>
            </React.Fragment>
          ))}
        </Grid>
      </Card>
    </Box>
  );
};

export default Details;
